import { Suspense, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes, useNavigate } from "react-router";
import i18n from "./locales/i18n";
import { checkFixLang, editTitle } from "./helpers/lang";
import ProtectedRoute from "./routes/ProtectedRoute/ProtectedRoute";
import Login from "./pages/Login/Login";
import {
  connectSocket,
  disconnectSocket,
  EVENTS,
  socket,
} from "services/socket/config";
import {
  listenToNotification,
  listNotification,
} from "services/socket/notification";
import { setNotifications } from "store/actions";
import { ROUTES } from "constants";
import ForgetPassword from "pages/Login/ForgotPassword";
import Register from "pages/Register/Register";
import RegisterHome from "pages/RegisterHome/RegisterHome";
import RegisterForm from "pages/RegisterForm/RegisterForm";
import { selectAuth } from "store/auth-slice";

function App() {
  let lang = i18n.language;
  const auth = useSelector(selectAuth);
  const navigate = useNavigate();

  useEffect(() => {
    checkFixLang(lang);
    editTitle(lang);
  }, [lang]);

  useEffect(() => {
    connectSocket();
    listenToNotification((first) => console.log(first));
    socket.on(EVENTS.CONNECTION.OPEN, () => {});
    listenToNotification((res) => console.log(res));
    listNotification();

    socket.on(EVENTS.NOTIFICATION.LIST, (response) =>
      setNotifications(response)
    );

    socket.on(EVENTS.CHAT.CREATE, (res) => {
      console.log(res);
      if (!res.success) {
        return;
      }
      const roomId = res.record?._id;
      navigate("/chat", { state: { roomId } });
      console.log(res);
    });
    return () => {
      socket.off(EVENTS.CONNECTION.OPEN);
      disconnectSocket();
    };
  }, []);
  return (
    <div className="App">
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/*" element={<ProtectedRoute />} />
          <Route
            path="/login"
            element={auth.token ? <Navigate to="/" /> : <Login />}
          />
          <Route
            path={ROUTES.FORGOT_PASSWORD}
            element={auth.token ? <Navigate to="/" /> : <ForgetPassword />}
          />
          <Route
            path="/register"
            element={auth.token ? <Navigate to="/" /> : <Register />}
          >
            <Route index element={<RegisterHome />} />
            <Route path="create" element={<RegisterForm />} />
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;

function Loader() {
  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <div
        className="inline-block h-28 w-28 animate-spin rounded-full border-8 border-solid border-primary/80 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
        role="status"
      >
        <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
          Loading...
        </span>
      </div>
    </div>
  );
}
